import { createAxiosInstance } from '@centric-os/platform';
import type { AxiosInstance } from 'axios';

// creating instance to query api.compassdigital.org BE API
export const cdlApi: AxiosInstance = createAxiosInstance();

// creating instance to query any generic API
export const genericAPI: AxiosInstance = createAxiosInstance({
  baseURL: '',
  skipAuthorization: true,
});

export default cdlApi;
